import Log from '../log';
function getStorage(type, key) {
    var storage = window[type];
    var json = /^[\{\[][\w\W]*[\}\]]$/;
    try {
        var item = storage.getItem(key) || undefined;
        return json.test(item)
            ? JSON.parse(storage.getItem(key)) || undefined
            : item;
    }
    catch (e) {
        /* istanbul ignore next */
        Log.error("[MFE Utils Store] " + type + " is unavailable");
        /* istanbul ignore next */
        return null;
    }
}
function setStorage(type, key, value) {
    var storage = window[type];
    var val;
    if (typeof value === 'object') {
        val = JSON.stringify(value);
    }
    else {
        val = value;
    }
    try {
        storage.setItem(key, val);
        return true;
    }
    catch (e) {
        /* istanbul ignore next */
        Log.error("[MFE Utils Store] " + type + " is unavailable");
        /* istanbul ignore next */
        return false;
    }
}
/**
 * Class for working with Store
 */
var Store = /** @class */ (function () {
    function Store() {
    }
    /**
     * Set or get value from localStorage
     * @param key
     * @param value
     */
    Store.localStore = function (key, value) {
        if (value === undefined) {
            return getStorage('localStorage', key);
        }
        else {
            return setStorage('localStorage', key, value);
        }
    };
    /**
     * Set or get value from sessionStorage
     * @param key
     * @param value
     */
    Store.sessionStore = function (key, value) {
        if (value === undefined) {
            return getStorage('sessionStorage', key);
        }
        else {
            return setStorage('sessionStorage', key, value);
        }
    };
    return Store;
}());
export default Store;
